import type { ComponentProps } from 'react';
import React from 'react';
import { Box, Flex, Text } from '@skin-seoul/design-system';
import ProductImage from '../components/ProductImage';
import { Condition } from '../../../utils/react/Condition';
import { useProductCard } from '../ProductCardContext';
import { isNil } from 'es-toolkit';
import { DiscountBadge } from '../components/DiscountBadge';

type ProductCardImageProps = {
  topSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
} & ComponentProps<typeof Box>;

export const HorizontalProductCardImage = ({ topSlot, bottomSlot, ...props }: ProductCardImageProps) => {
  const { ranking } = useProductCard();
  return (
    <Box
      position="relative"
      backgroundColor="neutral.50"
      width="132px"
      height="100%"
      padding="16px"
      minWidth="132px"
      alignItems="center"
      alignSelf="stretch"
      borderRadius="8px"
      boxSizing="border-box"
      {...props}
    >
      <Flex position="absolute" zIndex={2} top={0} left={0} width="100%">
        <>{topSlot}</>
      </Flex>
      <DiscountBadge />
      <ProductImage />
      <Condition
        expression={!isNil(ranking)}
        then={
          <Flex position="absolute" bottom={0} left={0} h={12} w={12} alignItems="center" justifyContent="center">
            <Text color="neutral.200" textStyle="heading.h2">
              {ranking}
            </Text>
          </Flex>
        }
      />
      <Flex position="absolute" bottom={0} zIndex={2} left={0} width="100%">
        <>{bottomSlot}</>
      </Flex>
    </Box>
  );
};
